export default "__VITE_ASSET__BZR_q3PF__"